<template>
  <div>
    <RelatorioPaisagem>
      <b-table
        striped
        small
        style="text-align: start"
        id="table_export_id"
        :head-variant="'light'"
        :items="parametro.dados"
        :fields="parametro.colunas"
      >
      </b-table>
    </RelatorioPaisagem>
  </div>
</template>

<script>
  import { formatarData, formatarValor } from '@/libs/utils'
  import pdfMake from 'pdfmake/build/pdfmake'
  import pdfFonts from 'pdfmake/build/vfs_fonts'
  import RelatorioPaisagem from '../../relatorioPaisagem.vue'

  export default {
    components: {
      pdfMake,
      pdfFonts,
      formatarValor,
      formatarData,
      RelatorioPaisagem,
    },
    props: {
      parametro: {},
    },
    data() {
      return {
        userData: this.$jwtDecode(localStorage.getItem('userData')).userData,
        formatarValor,
        formatarData,
      }
    },
  }
</script>
